import React, { useState } from 'react'
import { Button, ButtonProps } from './Button'
import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'
import { getRoomTrackingDetails } from '../../apps/professional-app/fa/tracking'
import { RoomSession } from '@zocks-communications/client-sdk-js'

export interface SessionShareButtonProps extends ButtonProps {
  roomSession: RoomSession
}
export const SessionShareButton: React.FC<SessionShareButtonProps> = ({ roomSession, ...rest }) => {
  const { tracked } = useTracking()
  const [sharingInProgress, setSharingInProgress] = useState(false)

  const _handleShareClick = async () => {
    await navigator.clipboard.writeText(`${window.location.href}`)
    setSharingInProgress(true)
    const timeout = setTimeout(() => {
      setSharingInProgress(false)
      clearTimeout(timeout)
    }, 1000)
  }

  const handleShare = tracked(_handleShareClick, { eventName: TrackEvent.SHARE_BUTTON_CLICKED, eventDetails: getRoomTrackingDetails(roomSession) })

  return (
    <>
      <Button {...rest} onClick={handleShare}>
        <i className='bi bi-share'></i>
        Share
      </Button>{' '}
      {sharingInProgress && <span>Meeting link copied to clipboard!</span>}
    </>
  )
}
